export function RegExpEscape(pattern) {
    return pattern.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
export function RegExpWrap(pattern) {
    return '(?:' + pattern + ')';
}
export function RegExpStartEnd(pattern) {
    return '^' + pattern + '$';
}
//# sourceMappingURL=regexp-helpers.js.map